module.exports = __webpack_public_path__ + "static/media/training.a03794ee.svg";